import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface BbgTickerFormFieldProps {
  placeholder?: string
}

export const BbgTickerFormField: React.FC<BbgTickerFormFieldProps> = ({ placeholder }) => {
  const { control, register } = useFormContext<{ bbg_ticker: string }>()

  return (
    <FormField
      name="bbg_ticker"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Bloomberg Ticker</FormLabel>
              <FormError />
            </div>
            <Input
              {...register('bbg_ticker')}
              placeholder={placeholder ?? 'Enter an bloomberg ticker'}
            />
          </FormItem>
        )
      }}
    />
  )
}
